export default "__VITE_ASSET__1c6a6d7a__"